import { useEnvoy } from "@/lib/hooks/envoy";
import { usePostingFits } from "@/lib/hooks/resume";
import { useStanding } from "@/lib/hooks/standingContext";
import { fitNow } from "@/lib/posting";
import type { TailorChoices } from "@/lib/posting/tailorChoices";
import { tailorTerms } from "@/lib/standing";
import TailorDialog, { type TailorPosting } from "./TailorDialog";

/**
 * The tailor dialog with what it reads: the resume's fit as it stands,
 * the envoy's saved instructions, and the plan's writer and cost. One that
 * cannot be read leaves its part out: the tailor can still go.
 */
export default function TailorAsk({
    posting,
    busy,
    onConfirm,
    onClose,
}: {
    posting: TailorPosting | null;
    busy: boolean;
    onConfirm: (choices: TailorChoices, added: string[]) => void;
    onClose: () => void;
}) {
    const standing = useStanding();
    const envoy = useEnvoy();
    const fits = usePostingFits(posting ? [posting.posting_id] : []);
    const found = posting ? fits.data?.[posting.posting_id] : undefined;
    const fit = found ? fitNow(found) : null;
    return (
        <TailorDialog
            posting={posting}
            covered={fit?.coveredTerms ?? []}
            missing={fit?.missing ?? []}
            savedInstructions={envoy.data?.settings.instructions ?? null}
            {...tailorTerms(standing)}
            busy={busy}
            onConfirm={onConfirm}
            onClose={onClose}
        />
    );
}
